import * as Types from '../../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetPopularDiseaseEncyclopediasDocument = `
    query GetPopularDiseaseEncyclopedias($limit: Int!) {
  popularDiseaseEncyclopedias(limit: $limit) {
    content
    title
    titleImageUrl
    publicId
  }
}
    `;
export const useGetPopularDiseaseEncyclopediasQuery = <
      TData = Types.GetPopularDiseaseEncyclopediasQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetPopularDiseaseEncyclopediasQueryVariables,
      options?: UseQueryOptions<Types.GetPopularDiseaseEncyclopediasQuery, TError, TData>,
    ) =>
    useQuery<Types.GetPopularDiseaseEncyclopediasQuery, TError, TData>(
      ['GetPopularDiseaseEncyclopedias', variables],
      gqlFetcher<Types.GetPopularDiseaseEncyclopediasQuery, Types.GetPopularDiseaseEncyclopediasQueryVariables>(GetPopularDiseaseEncyclopediasDocument, 'GetPopularDiseaseEncyclopedias', variables),
      options
    );

useGetPopularDiseaseEncyclopediasQuery.getKey = (variables: Types.GetPopularDiseaseEncyclopediasQueryVariables) => ['GetPopularDiseaseEncyclopedias', variables];
;

useGetPopularDiseaseEncyclopediasQuery.fetcher = (variables: Types.GetPopularDiseaseEncyclopediasQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetPopularDiseaseEncyclopediasQuery, Types.GetPopularDiseaseEncyclopediasQueryVariables>(GetPopularDiseaseEncyclopediasDocument, 'GetPopularDiseaseEncyclopedias', variables, options);